module.exports = __webpack_public_path__ + "assets/img/pjs_4.c3995d6d.png";